module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3cf9U"))).then(() => parcelRequire('d0iPb'));